module.exports = __webpack_public_path__ + "static/media/diamond_256x256-collected.3ecf89ad.png";